import { type ReactNode } from 'react'
import cx from 'classnames'
import styles from './HeadsUpBlock.module.css'
import { Icon } from '@/components/Icon'

export interface HeadsUpBlockProps {
  title?: ReactNode
  children?: ReactNode
  testId?: string
}

/**
 * A visual block that calls the attention of the reader.
 */
export function HeadsUpBlock({ title, children, testId }: HeadsUpBlockProps) {
  return (
    <div className={cx(styles.root)} data-test={testId}>
      <div className={styles.decoration}>
        <Icon sm name="info" variant="active" />
      </div>
      <div className={styles.main}>
        {title && <p className={styles.title}>{title}</p>}
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  )
}
